import { render, staticRenderFns } from "./More.vue?vue&type=template&id=24eb4a6a&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "./More.vue?vue&type=style&index=0&id=24eb4a6a&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports